export default class ExitConfirmationService {
    private exitConfirmationActive: boolean = false;

    public enableExitConfirmation() {
        this.exitConfirmationActive = true;
    }

    public disableExitConfirmation() {
        this.exitConfirmationActive = false;
    }

    public initialize() {
        window.onbeforeunload = () => {
            if (this.exitConfirmationActive) {
                return "Weet je zeker dat je deze pagina wilt sluiten? Mogelijke voortgang kan verloren raken!";
            }
        }
    }
}